import React from 'react'
import ReactDOMServer from 'react-dom/server'
import PharmacyCopyTemplate from './PharmacyCopyTemplate'
import CustomerCopyTemplate from './CustomerCopyTemplate'

export const INVOICE_COPY_TYPE = {
  PHARMACY_COPY: 'PHARMACY_COPY',
  CUSTOMER_COPY: 'CUSTOMER_COPY',
}

export const generateInvoiceHTML = (invoiceData, branchData, copyType) => {
  const TemplateComponent =
    copyType === INVOICE_COPY_TYPE.PHARMACY_COPY
      ? PharmacyCopyTemplate
      : CustomerCopyTemplate

  const html = ReactDOMServer.renderToStaticMarkup(
    <TemplateComponent invoiceData={invoiceData} branchData={branchData} />
  )

  return html
}

export const formatProductName = (product) => {
  let name = product.name || product.product_name
  if (product.dose) {
    name += ` (${product.dose})`
  }
  if (product.strength) {
    name += `-${product.strength}`
  }
  return name
}

export const formatPaymentMode = (mode) => {
  const modeMap = {
    CASH: 'Cash',
    CARD: 'Card',
    ONLINE: 'Online',
    CASH_CARD: 'Cash & Card',
    DUE_SALES: 'Due Sales',
  }
  return modeMap[mode] || mode
}

